import { TerritoryLevel } from "@mapmycustomers/shared";

import { RegionDemographicData } from "@app/store/mapLayers/boundaries/types/BoundariesLayerData";

export const levelToRegion: Record<TerritoryLevel, keyof RegionDemographicData> = {
  [TerritoryLevel.ADM1]: "state",
  [TerritoryLevel.ADM2]: "fips",
  [TerritoryLevel.ADM3]: "zip",
};

export const regionToLevel: Record<keyof RegionDemographicData, TerritoryLevel> = {
  fips: TerritoryLevel.ADM2,
  state: TerritoryLevel.ADM1,
  zip: TerritoryLevel.ADM3,
};

const getLevelData = (data: RegionDemographicData, level: TerritoryLevel) =>
  data[levelToRegion[level]];

export default getLevelData;
